import { classNames } from '@schuelerhilfe/shared/src/utils/classNames';
import { Button } from '@/components/Button';
import type { AppointmentDay } from '@/lib/appointments';

interface DayPickerProps {
  availableDays: AppointmentDay[];
  selectedDay: string | null;
  onSelect: (date: string) => void;
  onNext: () => void;
  ctaLabel: string;
  stackButtons?: boolean;
  /** CMS heading override; falls back to the previous hardcoded text. */
  heading?: string;
}

export const DayPicker = ({
  availableDays,
  selectedDay,
  onSelect,
  onNext,
  ctaLabel,
  stackButtons,
  heading,
}: DayPickerProps) => (
  <div>
    <p className="h3 mb-4 text-center">{heading || 'Wunschtermin wählen'}</p>
    <div className="mx-auto mb-8 flex flex-wrap justify-center gap-6">
      {availableDays.map((d) => (
        <button
          key={d.dateIso}
          type="button"
          onClick={() => onSelect(d.dateIso)}
          className={classNames(
            'flex shrink-0 grow-0 basis-[calc((100%-3rem)/3)] flex-col items-center rounded-2xl px-4 py-4 text-sm font-medium transition-colors md:basis-[calc((100%-7.5rem)/6)]',
            selectedDay === d.dateIso
              ? 'bg-primary text-white'
              : 'bg-[rgba(40,25,10,0.1)]',
          )}
        >
          <span>{d.day}</span>
          <span>{d.date}</span>
        </button>
      ))}
    </div>
    <div className="text-center">
      <Button
        size="lg"
        disabled={!selectedDay}
        onClick={onNext}
        className={classNames('w-full', !stackButtons && 'md:w-sm')}
      >
        {ctaLabel}
      </Button>
    </div>
  </div>
);
